import React, { useEffect, useState } from 'react'
import { TableHeader, TableLoader } from '../../commons'
import { RecurringJobsTableHeader } from '../../../constant/tableHeadersConstants/Jobs/recurringJobsTableHeader'
import { DropDownType } from '../../../commonTypes/clientDirectoryTypes'
import RecurringJobsSettingInput from './RecurringJobsSettingInput'
import { PlusIconCircle } from '../../Icon'
import { RootState } from '../../../redux/rootReducers'
import { connect } from 'react-redux'
import { getAllFinacGovtOfficerAction, getAllFinacManagerAction, getAllFinacUsersAction, resetFinacGovtOfficerList, resetFinacManagerList, resetFinacUsersList, resetTotalGovtOfficerCount, resetTotalManagerCount } from '../../../redux/auth'
import { GetAllFinacUserPayloadType } from '../../../commonTypes/authTypes'
import useDebounce from '../../../customHooks/useDebounce'
import { getJobsTypeListAction, getSingleJobsTypeAction, resetFetching, resetJobsTypeList, resetSingleJobs, resetSingleJobsType, resetTotalCount } from '../../../redux/jobs'
import { GetJobsListTypePayload, SingleJobTypePayload } from '../../../commonTypes/jobsType'
import {formatDateInYear, } from '../../../utils/commonFunctions'
import { useMenuCheck } from '../../../customHooks/useMenuCheck'

export type RecurringJobsSettingInputType = {
    jobType: DropDownType,
    description: string,
    nextJobDate: string,
    jobTypeError: string,
    managerError: string,
    responsibleError: string,
    govtOfficerError: string;
    reqId: string,
    manager: DropDownType,
    responsible: DropDownType,
    govtOfficer: DropDownType,
    engagementCutoffDate: string | null,
    dateChanged:boolean
}
const recurringJobsSettingInput: RecurringJobsSettingInputType[] = [
    {
        jobType: {
            value: null,
            label: "Select.."
        },
        description: "",
        nextJobDate: "",
        manager: {
            value: null,
            label: "Select.."
        },
        responsible: {
            value: null,
            label: "Select.."
        },
        govtOfficer: {
            value: null,
            label: "Select.."
        },
        engagementCutoffDate: null,
        dateChanged: true,
        jobTypeError: "",
        managerError: "",
        responsibleError: "",
        govtOfficerError: "",
        reqId: ""
    }
]

type AppProps = {
    history: any;
    token: string | null;
    finacUser: any;
    finacManagerList: any;
    userFetching: boolean;
    fetching: boolean;
    jobTypeFetching: boolean;
    managerFetching: boolean;
    jobsTypeList: any;
    jobDetails: any;
    totalManagerCount: string | number;
    success: number | null;
    singleJobsType: any;
    formError: boolean;
    clientName: DropDownType;
    totalJobsTypeCount: number;
    finacGovtOfficerList: any;
    officerFetching: boolean;
    totalGovtOfficerCount: string | number;
    handleSubmit: (data: any) => void;
    dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
    dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => void;
    dispatchGetAllFinacGovtOfficerAction: (data: GetAllFinacUserPayloadType) => void;
    dispatchGetAllJobsTypeListAction: (data: GetJobsListTypePayload) => void;
    dispatchGetSingleJobsDetailsAction: (data: SingleJobTypePayload) => void;
    dispatchResetFinacManagerList: () => void;
    dispatchResetFinacUsersList: () => void;
    dispatchResetTotalManagerCount: () => void;
    dispatchResetSingleJobs: () => void;
    dispatchResetTotalCount: () => void;
    dispatchResetFetching: () => void;
    dispatchResetSingleJobsType: () => void;
    dispatchResetJobsType: () => void;
    dispatchResetFinacGovtOfficerList: () => void;
    dispatchResetTotalGovtOfficerCount: () => void;
}

const RecurringJobsTable = ({
    history,
    token,
    finacUser,
    fetching,
    jobTypeFetching,
    userFetching,
    handleSubmit,
    success,
    clientName,
    dispatchGetAllFinacUsersAction,
    dispatchGetAllFinacManagerAction,
    dispatchGetAllFinacGovtOfficerAction,
    finacManagerList,
    totalManagerCount,
    managerFetching,
    jobsTypeList,
    totalJobsTypeCount,
    jobDetails,
    officerFetching,
    totalGovtOfficerCount,
    finacGovtOfficerList,
    dispatchResetFinacManagerList,
    dispatchResetFinacUsersList,
    dispatchResetTotalManagerCount,
    dispatchGetAllJobsTypeListAction,
    dispatchGetSingleJobsDetailsAction,
    singleJobsType,
    dispatchResetSingleJobs,
    dispatchResetTotalCount,
    dispatchResetFetching,
    dispatchResetSingleJobsType,
    dispatchResetJobsType,
    dispatchResetTotalGovtOfficerCount,
    dispatchResetFinacGovtOfficerList,
}: AppProps) => {
    const [recurringJobsSettingInputData, setRecurringJobsSettingInputData] = useState(JSON.parse(JSON.stringify(recurringJobsSettingInput)))
    const [finalUserList, setFinalUserList] = useState<any>([]);
    const [finalManagerList, setFinalManagerList] = useState<any>([]);
    const [finalJobTypeList, setFinalJobTypeList] = useState<any>([]);
    const [managerText, setManagerText] = useState<string>("");
    const [managerLimit, setManagerLimit] = useState<number>(20);
    const [managerOffset, setManagerOffset] = useState<number>(0);
    const [text, setText] = useState<string>("");
    const [limit, setLimit] = useState<number>(20);
    const [offset, setoffset] = useState<number>(0);
    const [jobTypeText, setJobTypeText] = useState<string>("");
    const [jobTypeLimit, setJobTypeLimit] = useState<number>(100);
    const [jobTypeOffset, setJobTypeOffset] = useState<number>(0);
    const [isAddRecurringPresent,setIsAddRecurringPresent] = useMenuCheck();
    const [isSaveRecurringPresent,setIsSaveRecurringPresent]=useMenuCheck();
    const [jobType, setJobType] = useState({
        label: "Select..",
        value: null
    })
    const [govtOffset, setGovtOffset] = useState<number>(0);
    const [govtText, setGovtText] = useState<string>("");
    const [govtLimit, setGovtLimit] = useState<number>(20);
    const [finalGovtOfficerList, setFinalGovtOfficerList] = useState<any>([]);
    const [submit, setSubmit] = useState(false)
    const redirectClientName = history?.location?.state?.companyName;
    const redirectClientCode = history?.location?.state?.clientCode;
    const persistJobType= history?.location?.state?.jobType;
    const sortByCc=history?.location?.state?.sortByCc;
    const searchTerm = history?.location?.state?.searchTerm


    useEffect(() => {
        setIsAddRecurringPresent("Add Recurring","menu")
        setIsSaveRecurringPresent("Save Recurring","menu")
        dispatchResetFinacManagerList();
        dispatchResetFinacUsersList();
        dispatchResetTotalManagerCount();
        dispatchResetSingleJobs();
        dispatchResetTotalCount();
        dispatchResetFetching();
        dispatchResetSingleJobsType();
        dispatchResetJobsType();
        dispatchResetTotalGovtOfficerCount();
        dispatchResetFinacGovtOfficerList();
    }, [])

    useEffect(() => {
        if (success) {
            setRecurringJobsSettingInputData(JSON.parse(JSON.stringify(recurringJobsSettingInput)))
        }
    }, [success])

    useEffect(() => {
        if (jobType?.value) {
            const finalData = {
                token,
                id: jobType?.value,
            }
            dispatchGetSingleJobsDetailsAction(finalData)
        }
    }, [jobType?.value])

useEffect(() => {
    if (jobDetails) {
            let arr: any = []
            jobDetails?.map((data: any) => {
                arr.push({
                    jobType: {
                        value: data?.job_type?._id,
                        label: data?.job_type?.job_type ? data?.job_type?.job_type : "Select.."
                    },
                    description: data?.description,
                    nextJobDate: data?.next_job_date,
                    manager: {
                        value: data?.manager?.user_id,
                        label: data?.manager?.first_name ? `${data?.manager?.first_name} ${data?.manager?.last_name ? data?.manager?.last_name : ""}` : "Select.."
                    },
                    responsible: {
                        value: data?.responsible?.user_id,
                        label: data?.responsible?.first_name ? `${data?.responsible?.first_name} ${data?.responsible?.last_name ? data?.responsible?.last_name : ""}` : "Select.."
                    },
                    govtOfficer: {
                        value: data?.govt_officer?.user_id,
                        label: data?.govt_officer?.first_name ? `${data?.govt_officer?.first_name} ${data?.govt_officer?.last_name ? data?.govt_officer?.last_name : ""}` : "Select.."
                    },
                    engagementCutoffDate: data?.engagement_cutoff_date,
                    dateChanged:true,
                    reqId:data?._id
                })
            })
            setRecurringJobsSettingInputData(arr)
        } else {
            setRecurringJobsSettingInputData(JSON.parse(JSON.stringify(recurringJobsSettingInput)))
        }
    }, [jobDetails,clientName?.value])


    useEffect(() => {
        const jobTypeListData = jobsTypeList?.map((data: any) => {
            return {
                value: data?._id,
                label: data?.job_type
            }
        })
        if (jobTypeOffset > 0) {
            setFinalJobTypeList([...finalJobTypeList, ...jobTypeListData])
        } else {
            setFinalJobTypeList(jobTypeListData)
        }
    }, [jobsTypeList])

    useEffect(() => {
        const finalUserData = finacUser?.data?.map((user: any) => {
            return {
                value: user?.user_id,
                label: `${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""} `,
                image: user?.profile_pic?.file_url
            };
        })
        if (offset > 0) {
            setFinalUserList([...finalUserList, ...finalUserData]);
        } else {
            setFinalUserList(finalUserData);
        }
    }, [finacUser])

    useEffect(() => {
        const finalManagerData = finacManagerList?.map((user: any) => {
            return {
                value: user?.user_id,
                label: `${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""} `,
                image: user?.profile_pic?.file_url
            };
        })
        if (managerOffset > 0) {
            setFinalManagerList([...finalManagerList, ...finalManagerData]);
        } else {
            setFinalManagerList(finalManagerData);
        }
    }, [finacManagerList])

    useEffect(() => {
        const finalGovtOfficerData = finacGovtOfficerList?.map((user: any) => {
            return {
                value: user?.user_id,
                label:`${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""} `,
                image: user?.profile_pic?.file_url
            };
        })
        if (govtOffset > 0) {
            setFinalGovtOfficerList([...finalGovtOfficerList, ...finalGovtOfficerData]);
        } else {
            setFinalGovtOfficerList(finalGovtOfficerData)
        }
    }, [finacGovtOfficerList])

    useEffect(() => {

        if (token) {
            let finalUserData = {
                token,
                offset: jobTypeOffset,
                limit: jobTypeLimit,
                search_term: jobTypeText,
                recurring: 1
            };
            if (jobTypeOffset <= totalJobsTypeCount) {
                dispatchGetAllJobsTypeListAction(finalUserData)
            }
        }
    }, [jobTypeOffset])

    useEffect(() => {
        if (token) {
            let finalUserData = {
                token,
                offset,
                limit,
                user_type: 'stco_users',
                status: 1,
                search_term: text,
            };
            if (offset <= finacUser?.total_count) {
                dispatchGetAllFinacUsersAction(finalUserData)
            }
        }
    }, [offset])

    useEffect(() => {
        if (token) {
            let finalUserData = {
                token,
                offset: managerOffset,
                limit: managerLimit,
                user_type: 'manager',
                status: 1,
                search_term: managerText,
            };
            if (managerOffset <= +totalManagerCount) {
                dispatchGetAllFinacManagerAction(finalUserData)
            }
        }
    }, [managerOffset])

        useEffect(() => {
            if (token) {
                const finalData = {
                    token,
                    offset: govtOffset,
                    limit: govtLimit,
                    user_type: 'govt_officer',
                    status: 1,
                    search_term: govtText,
                };
                if (govtOffset <= +totalGovtOfficerCount) {
                    dispatchGetAllFinacGovtOfficerAction(finalData)
                }
            }
        }, [govtOffset])

    const fetchJobTypeNewData = (search: string) => {
        const finalData = {
            token,
            offset: jobTypeOffset,
            limit: jobTypeLimit,
            search_term: jobTypeText,
            recurring: 1
        }
        dispatchGetAllJobsTypeListAction(finalData)
    }

    useDebounce(() => {
        dispatchResetJobsType()
        if (jobTypeText) {
            if (jobTypeOffset === 0) {
                
                fetchJobTypeNewData(jobTypeText)
            }
            else {
                setJobTypeOffset(0)
            }
        }
        else {
            const finalData = {
                token,
                offset: jobTypeOffset,
                limit: jobTypeLimit,
                search_term: jobTypeText,
                recurring: 1
            }
            dispatchGetAllJobsTypeListAction(finalData)
        }
    }, 500, [jobTypeText]);

    const fetchNewData = (search: string) => {
        const finalData = {
            token,
            offset,
            limit,
            user_type: 'stco_users',
            status: 1,
            search_term: text,
        }
        dispatchGetAllFinacUsersAction(finalData)
    }

    useDebounce(() => {
        if (text) {
            fetchNewData(text)
        }
        else {
            const finalData = {
                token,
                offset,
                limit,
                user_type: 'stco_users',
                status: 1,
                search_term: text,
            }
            dispatchGetAllFinacUsersAction(finalData)
        }
    }, 500, [text]);

    const fetchNewManagerData = (search: string) => {
        const finalData = {
            token,
            offset: managerOffset,
            limit: managerLimit,
            user_type: 'manager',
            status: 1,
            search_term: managerText,
        }
        dispatchGetAllFinacManagerAction(finalData)
    }

    useDebounce(() => {
        if (managerText) {
            fetchNewManagerData(managerText)
        }
        else {
            const finalData = {
                token,
                offset: managerOffset,
                limit: managerLimit,
                user_type: 'manager',
                status: 1,
                search_term: managerText,
            }
            dispatchGetAllFinacManagerAction(finalData)
        }
    }, 500, [managerText]);

    const fetchNewGovtOfficerData = (search: string) => {
        const finalData = {
            token,
            offset: govtOffset,
            limit: govtLimit,
            user_type: 'govt_officer',
            status: 1,
            search_term: govtText,
        }
        dispatchGetAllFinacGovtOfficerAction(finalData)
    }

    useDebounce(() => {
        if(govtText) {
            fetchNewGovtOfficerData(govtText)
        }
        else{
            const finalData = {
                token,
                offset: govtOffset,
                limit: govtLimit,
                user_type: 'govt_officer',
                status: 1,
                search_term: govtText,                
            }
            dispatchGetAllFinacGovtOfficerAction(finalData)
        }
    }, 500, [govtText]);

    const handleRemoveRow = (index: number) => {
        setJobType({
            value: null,
            label: "Select.."
        })
        let temp = JSON.parse(JSON.stringify(recurringJobsSettingInputData));
        temp.splice(index, 1)
        setRecurringJobsSettingInputData(temp)
    }

    const handleAddAnotherRow = () => {
        let temp = JSON.parse(JSON.stringify(recurringJobsSettingInputData));
        temp.push(...JSON.parse(JSON.stringify(recurringJobsSettingInput)));
        setRecurringJobsSettingInputData(temp);
    }

    const handleRecurringInputDetailsChange = (dataKey: any,
        value: any,
        index: number) => {
        let temp = JSON.parse(JSON.stringify(recurringJobsSettingInputData))
        if (value === "Invalid date") {
            temp[index][dataKey] = "";
        }
        else if (dataKey === "jobType") {
            setJobType(value)
            temp[index][dataKey] = value;
            temp[index]["jobTypeError"] = "";
            temp[index]["manager"].value = null;
            temp[index]["manager"].label = "Select..";
            temp[index]["responsible"].value = null;
            temp[index]["responsible"].label = "Select..";
            // temp[index]["govtOfficer"].value = null;
            // temp[index]["govtOfficer"].value = "Select..";
        }
        else if (dataKey === "manager") {
            temp[index][dataKey] = value;
            temp[index]["managerError"] = "";
        }
        else if (dataKey === "responsible") {
            temp[index][dataKey] = value;
            temp[index]["responsibleError"] = "";
        }
        // else if (dataKey === "govtOfficer") {
        //     temp[index][dataKey] = value;
        //     temp[index]["govtOfficerError"] = "";
        // }
        else {
            temp[index][dataKey] = value;
        }
        setRecurringJobsSettingInputData([...temp]);
    }

    const handleSaveRecurringData = () => {
        setSubmit(true)
        recurringJobsSettingInputData?.map((data: any, index: number) => {
            for(let i in jobDetails){
                if(data.jobType?.value==jobDetails[i].job_type._id){                    
                    if((formatDateInYear(data?.engagementCutoffDate)==jobDetails[i]?.engagement_cutoff_date?.split("T")[0])||(data?.engagementCutoffDate==null&&jobDetails[i]?.engagement_cutoff_date?.split("T")[0]==null)){
                        data.dateChanged=false
                    }
                }
            }
            if (!data?.jobType?.value) {
                data.jobTypeError = "job type required"
            }
            if (!data?.manager?.value) {
                data.managerError = "manager required"
            }
            if (!data?.responsible?.value) {
                data.responsibleError = "responsible required"
            }
            // if(!data?.govtOfficer?.value) {
            //     data.govtOfficerError = "officer required"
            // }
        })

        setRecurringJobsSettingInputData([...recurringJobsSettingInputData])
        handleSubmit(recurringJobsSettingInputData)
    }
    return (
        <>
            {fetching && jobTypeOffset === 0 ? <TableLoader Rows={7} ColumnPerRow={5} /> : <>
                <div className='mt-4' style={{ width: "100%" }}>
                    <div className='disbursment'>
                        <table className='table' style={{ borderBottom: "0.2px solid rgba(191, 203, 225, 0.6)" }}>
                            <thead className='thead-slight'>
                                <TableHeader tableHeader={RecurringJobsTableHeader} />
                            </thead>
                            <tbody className={clientName?.value ? "" : 'col-md-12'}>
                                {clientName?.value && <RecurringJobsSettingInput
                                    singleJobsType={singleJobsType}
                                    setJobTypeOffset={setJobTypeOffset}
                                    setJobTypeText={setJobTypeText}
                                    jobTypeLimit={jobTypeLimit}
                                    setoffset={setoffset}
                                    setText={setText}
                                    limit={limit}
                                    text={text}
                                    setManagerOffset={setManagerOffset}
                                    setManagerText={setManagerText}
                                    managerLimit={managerLimit}
                                    userFetching={userFetching}
                                    fetching={jobTypeFetching}
                                    managerFetching={managerFetching}
                                    finalJobTypeList={finalJobTypeList}
                                    finalUserList={finalUserList}
                                    finalManagerList={finalManagerList}
                                    recurringJobsSettingInputData={recurringJobsSettingInputData}
                                    handleRemoveRow={handleRemoveRow}
                                    handleRecurringInputDetailsChange={handleRecurringInputDetailsChange}
                                    officerFetching={officerFetching}
                                    setGovtOffset={setGovtOffset}
                                    setGovtText={setGovtText}
                                    govtLimit={govtLimit}
                                    finalGovtOfficerList={finalGovtOfficerList}
                                />}
                            </tbody>
                        </table>
                        {clientName?.value===null &&
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "200px",fontSize:"18px"}}>
                                Please Select Client to Add Recurring Job
                            </div>
                        }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 m-4'>
                       {isAddRecurringPresent && <button
                            className='btn btn-outline'
                            onClick={handleAddAnotherRow}
                            disabled={!clientName?.value}
                        >
                            <span>
                                <PlusIconCircle /> {(clientName?.value && recurringJobsSettingInputData?.length!==0)?"Add More":"Add"}
                            </span>
                        </button>}
                    </div>
                </div>
                <hr></hr>
                <div className='row mt-4 mb-4 mr-3'>
                    <div className='col-md-12 text-right'>
                        <button
                            className='btn'
                            style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
                            onClick={() => {
                                history.push({
                                    pathname: `/jobs/recurring-jobs`,
                                    state: { companyName: redirectClientName, clientCode: redirectClientCode ,jobType:persistJobType,sortByCc , searchTerm}
                                })
                            }    
                            }>
                            Cancel
                        </button>
                       {isSaveRecurringPresent &&  <button className='btn btn-primary'
                            onClick={handleSaveRecurringData}
                        >
                            Save Changes
                        </button>}
                    </div>
                </div>
            </>
            }
        </>
    )
}

const mapStateToProps = ((state: RootState) => ({
    token: state.auth.token,
    jobsTypeList: state.jobs.jobsTypeList,
    fetching: state.jobs.fetching,
    jobTypeFetching: state.jobs.jobTypeFetching,
    finacUser: state.auth.finacUsersList,
    userFetching: state.auth.fetching,
    managerFetching: state.auth.managerFetching,
    finacManagerList: state.auth.finacManagerList,
    totalManagerCount: state.auth.totalManagerCount,
    totalJobsTypeCount: state.jobs.jobsTypeListTotalCount,
    singleJobsType: state.jobs.singleJobsType,
    officerFetching: state.auth.gotvOfficerFetching,
    totalGovtOfficerCount: state.auth.totalGovtOfficerCount,
    finacGovtOfficerList: state.auth.finacGovtOfficerList,

}))

const mapDispatchToProps = ((dispatch: any) => ({
    dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacUsersAction(data)),
    dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacManagerAction(data)),
    dispatchGetAllJobsTypeListAction: (data: GetJobsListTypePayload) => dispatch(getJobsTypeListAction(data)),
    dispatchGetSingleJobsDetailsAction: (data: SingleJobTypePayload) => dispatch(getSingleJobsTypeAction(data)),
    dispatchGetAllFinacGovtOfficerAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacGovtOfficerAction(data)),
    dispatchResetFinacManagerList: () => dispatch(resetFinacManagerList()),
    dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
    dispatchResetTotalManagerCount: () => dispatch(resetTotalManagerCount()),
    dispatchResetSingleJobs: () => dispatch(resetSingleJobs()),
    dispatchResetTotalCount: () => dispatch(resetTotalCount()),
    dispatchResetFetching: () => dispatch(resetFetching()),
    dispatchResetSingleJobsType: () => dispatch(resetSingleJobsType()),
    dispatchResetJobsType: () => dispatch(resetJobsTypeList()),
    dispatchResetTotalGovtOfficerCount: () => dispatch(resetTotalGovtOfficerCount()),
    dispatchResetFinacGovtOfficerList: () => dispatch(resetFinacGovtOfficerList()),
}))

export default connect(mapStateToProps, mapDispatchToProps)(RecurringJobsTable)